import styled from 'styled-components';
import { tabletMediaQuery, themeColor } from '../../../Theming';

const ButtonLink = styled.a`
  border-radius: 29px;
  width: 238px;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  padding: 11px 0;
  color: ${themeColor('smokeyWhite')};
  border: 2px solid ${themeColor('smokeyWhite')};
  display: flex;
  justify-content: center;

  ${tabletMediaQuery} {
    width: 162px;
  }

  &:focus {
    text-decoration: none;
  }
  &:hover {
    box-shadow: 0 1px 6px 0 ${themeColor('smokeyWhite')};
  }
  &:active {
    border: 2px solid ${themeColor('grey')};
    color: ${themeColor('grey')};
  }
`;

export default ButtonLink;
